module.exports = ["one world, one face.","1つの世界、1つの顔。","um mundo, uma cara.","eine welt, ein gesicht.","un mondo, una faccia.","en verden, et ansigt.","一个世界，一个脸。एक दुनिया, एक चेहरा।","un mundo, una cara","один мир, одно лицо.","عالم واحد ، وجه واحد.","এক বিশ্ব, এক মুখ.","satu dunia, satu wajah.","un monde, un visage.","하나의 세계, 하나의 얼굴.","một thế giới, một khuôn mặt.","tek dünya, tek yüz.","один світ, одне обличчя."]


//////////////////
// WEBPACK FOOTER
// ./src/assets/data/world.json
// module id = 378
// module chunks = 3